export { translate } from './translate';
export type { ITranslateProps } from './ITranslateProps';
